import axios from 'axios'
import { Message } from 'element-ui'

// COmfyUI基础参数服务
const request = axios.create({
  baseURL: 'http://8.155.53.4:6080',
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 添加请求拦截器
request.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  return config
}, function (error) {
  // 对请求错误做些什么
  Message.error('请求拦截失败')
  return Promise.reject(error)
})

//  添加响应拦截器
request.interceptors.response.use(response => {
  return response.data
}, error => {
  const { response } = error
  if (response && response.status >= 400) {
    Message.error(`请求失败：${response.status} - ${response.statusText}`)
  } else if (!window.navigator.onLine) {
    Message({
      message: '网络已断开，请检查网络连接||或联系管理员检查!',
      duration: 5000,
      type: 'error'
    })
  } else {
    Message({
      message: '请求异常,请稍后再试||或联系管理员检查!',
      duration: 5000,
      type: 'error'
    })
  }
  return Promise.reject(error)
})

export default request
